//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // sessionStorage.setItem("hid", this.$router.currentRoute.query.hid);
  
    // sessionStorage.setItem("hid", 1);

  },
  mounted() {},
  methods: {
   
    getUrlCode(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  }
};



// WEBPACK FOOTER //
// ./src/App.vue